var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-wrap"},[_c('div',{staticClass:"fx-fill fx-center-middle"},[_c('van-empty',{attrs:{"image":require('@/assets/images/error/404.png'),"description":"您的页面丢失了"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }